// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YkWUe","modeBtn":"styles_modeBtn__bFt0M","active":"styles_active__V4BvM"};